import { render, staticRenderFns } from "./PromotionAddPosFree.vue?vue&type=template&id=2d6acf08&scoped=true&"
import script from "./PromotionAddPosFree.vue?vue&type=script&lang=js&"
export * from "./PromotionAddPosFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6acf08",
  null
  
)

export default component.exports